import { render, staticRenderFns } from "./ModBalanceTow.vue?vue&type=template&id=518cf861&scoped=true"
import script from "./ModBalanceTow.vue?vue&type=script&lang=js"
export * from "./ModBalanceTow.vue?vue&type=script&lang=js"
import style0 from "./ModBalanceTow.vue?vue&type=style&index=0&id=518cf861&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518cf861",
  null
  
)

export default component.exports